import moment from 'moment';
import { MetricTrend } from '../types/adminAnalytics.ts';

export function getDefaultAnalyticsPeriod(): { from: string; to: string } {
  const to = moment().endOf('day');
  const from = moment().subtract(29, 'days').startOf('day');
  return {
    from: from.toISOString(),
    to: to.toISOString(),
  };
}

export function toDateInputValue(iso: string): string {
  return moment(iso).format('YYYY-MM-DD');
}

export function fromDateInputValue(value: string, endOfDay = false): string {
  const m = moment(value, 'YYYY-MM-DD');
  return (endOfDay ? m.endOf('day') : m.startOf('day')).toISOString();
}

export function formatDeltaPercent(deltaPercent: number | null): string {
  if (deltaPercent === null) return 'Nuevo';
  const sign = deltaPercent > 0 ? '+' : '';
  return `${sign}${deltaPercent}%`;
}

export function formatDeltaValue(delta: number): string {
  const sign = delta > 0 ? '+' : '';
  return `${sign}${delta}`;
}

export function trendLabel(trend: MetricTrend): string {
  switch (trend) {
    case 'up':
      return 'Sube';
    case 'down':
      return 'Baja';
    case 'flat':
      return 'Sin cambio';
    default:
      return '—';
  }
}
